import { createRootRoute, redirect } from '@tanstack/react-router'
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools'
import { authTokenStore } from '@/shared/api'
import { AppShell } from '@/widgets/app-shell'

export const Route = createRootRoute({
  beforeLoad: ({ location }) => {
    const token = authTokenStore.getState().token
    if (!token && location.pathname !== '/login') {
      throw redirect({ to: '/login' })
    }
  },
  component: () => (
    <>
      <AppShell />
      {import.meta.env.DEV && <TanStackRouterDevtools position="bottom-right" />}
    </>
  ),
})
